export default {
    zh: {
        title: 'FPA-Permanent',
        fpaNo: 'FPA Number',
        fpaName: 'FPA Name',
        fpaReleaseDate: 'FPA发布日期',
        materialNo: 'Local Number',
        materialName: 'Item Name',
        agreementLife: 'Agreement Date',
        agreementStartDate: 'Agreement Start Date',
        agreementEndDate: 'Agreement End Date',
        fpaQuery: 'FPA List',
        qpcnQuery: 'Item List',
        fpaDownload: 'Download by FPA',
        materialDownload: 'Download by Item List',
        pdfDownload: 'Download by PDF',
        materialNoPlaceHolder: 'Support multiple item search ,separated by English comma',
        FacilityName: 'Facility Name',
        ProductDescription: 'Product Description',
        currentPricePerUom: 'Current Price Per UoM',
        newPricePerUom: 'New Price Per UoM',
        validFrom: 'Price Valid From',
        validTo: 'Price Valid To',
        transportaionMethod: 'Delivery Type',
        pleaseChooseToDelete: 'Please Select A FPA To Delete!',
        pleaseChooseToWithdraw: 'Please Select A FPA To Withdraw!',
        checkDelete: 'Data can only be deleted at draft or reject status！',
        checkWithdraw: 'Drafts and approved documents cannot be withdrawn',
        sureDelete: 'Would you like to delete the selected record？',
        sureWithdraw: 'Would you like to withdraw the selected record？',
        detail: 'FPA Detail',
        city: 'City',
        isNew: 'New Item',
        Category1Check: 'Please Maintain Category1',
        Category2Check: 'Please Maintain Category2',
        supplierCheck: 'Please select a Supplier  first',
        agreementStartDateCheck: 'Please Maintain Agreement Start Date',
        agreementEndDateCheck: 'Please Maintain Agreement End Date',
        productOrCommodityPurchasedCheck: 'Please Maintain Product Or Commodity Purchased',
        fpaPcnDelCheck: 'Please Delete Transportation And Warehouse',
        attachmentUpload: 'Upload Attachment',
        signatureUpload: 'Upload Signoff Document',
        attachmentDownload: 'Download Attachment',
        signatureDownload: 'Download Signoff Document',
        audit: 'Approve',
        auditPerson: 'Approver',
        auditDate: 'Approval Date',
        auditResult: 'Approve Status',
        auditRemark: 'Revisions Suggestion',
        auditAppove: 'Approve',
        auditReject: 'Reject',
        pleaseChooseAuditResult: 'Please Select Approve Status！',
        pleaseInputAuditRemark: "The Revisions Suggestion Can't Be Empty When Reject",
        logicStatus: 'Approver',
        pleaseChooseSupplier: 'Please select a facility  first!',
        localItemExistCheck: 'Please enter Item Code',
        pleaseChooseToCopy: 'Please Select A FPA To Copy!',
        deadline: 'Expiry date From',
        toExpireCount: 'Expiry within three months',
        expiredCount: 'Expiry',
        materialToExpireCount: 'Expiry within three months',
        materialSixMonthExpireCount: 'Expiry within six months',
        materialExpiredCount: 'Expiry',
        pleaseMaintainNotionalValueOfAgreement: 'Please Maintain Notional Value Of Agreement',
        pleaseMaintainSSCategoryLeaderId: 'Please Select SSCategoryLeader',
        pleaseMaintainPqcp: 'Please Maintain PQCP',
        pleaseMaintainAgreedSupply: 'please maintain Agreed Supply Quantity',
        priceError: 'Please Maintain newPricePerUom 和 volumeEstimation',
        no: 'No.',
        productDescErr: 'Please Maintain ProductDescription',
        validDateCheck: ' 行数据 ValidDate 开始时间要早于结束时间',
        dcError: 'Please Maintain Supplier DC',
        returnToSupplier: 'Back',
        pleaseChooseApprovedToCopy: "Only approved FPA copy creation can be selected",
        numSixBitCheck: 'Please enter six decimal places！',
        adpRate: 'ADP Rate',
        adpRateCheck: 'You can only enter decimals greater than or equal to 0 and less than or equal to 1!',
        adpWithoutVatTotalCheck: 'input value is not equal to sum of adp without Vat in PQCP table',
        adpWithVatTotalCheck: 'input value is not equal to sum of adp with Vat in PQCP table',
        newPricePerUomSameCheck: 'new Price Per Uom is different',
        validDateFromSameCheck: 'Valid Date From is different',
        transportaionMethodSameCheck: 'transportaion Method is different',
        suppliedDcSameCheck: 'Duplicate DC exists',
        dcListCheck:'DC list cannot be empty',
        sourceType:'创建部门',
    },
    en: {
        title: 'FPA-Permanent',
        fpaNo: 'fpaNo',
        fpaName: 'fpaName',
        fpaReleaseDate: 'fpaReleaseDate',
        materialNo: 'Local Number',
        materialName: 'materialName',
        agreementLife: 'agreementLife',
        agreementStartDate: 'agreementStartDate',
        agreementEndDate: 'agreementEndDate',
        fpaQuery: 'FPAQuery',
        qpcnQuery: 'MaterialQuery',
        fpaDownload: 'FPA Download',
        materialDownload: 'Material Download',
        pdfDownload: 'PDF Download',
        materialNoPlaceHolder: 'Support multiple item search ,separated by English comma',
        FacilityName: 'Facility Name',
        currentPricePerUom: 'Current Price Per UoM',
        newPricePerUom: 'New Price Per UoM',
        validFrom: 'Price Valid From',
        validTo: 'Price Valid To',
        transportaionMethod: 'Transportation Method',
        pleaseChooseToDelete: 'Please choose record to delete',
        pleaseChooseToWithdraw: 'Please Select A FPA To Withdraw!',
        checkDelete: 'Records can only be deleted in the new / reject status',
        checkWithdraw: 'Drafts and approved documents cannot be withdrawn',
        sureDelete: 'Are you sure to delete these records?',
        sureWithdraw: 'Would you like to withdraw the selected record？',
        detail: 'FPA Permanent > View',
        city: 'City',
        isNew: 'isNew',
        Category1Check: 'Please maintain Category1',
        Category2Check: 'Please maintain Category2',
        supplierCheck: 'Please maintain supplier',
        agreementStartDateCheck: 'Please maintain Agreement Start Date',
        agreementEndDateCheck: 'Please maintain Agreement End Date',
        productOrCommodityPurchasedCheck: 'Please maintain Product Or Commodity Purchased',
        fpaPcnDelCheck: 'Please delete in pairs for Transportation and Warehouse',
        attachmentUpload: 'AttachmentUpload',
        audit: 'Audit',
        auditPerson: 'Audit Person',
        auditDate: 'Audit Date',
        auditResult: 'Audit Result',
        auditRemark: 'Recommendation',
        auditAppove: 'Appove',
        auditReject: 'Reject',
        pleaseChooseAuditResult: 'please choose audit result',
        pleaseInputAuditRemark: 'please input recommendation',
        logicStatus: 'Current status',
        attachmentDownload: 'Attachment Download',
        pleaseChooseSupplier: 'Please choose supplier first!',
        localItemExistCheck: 'Local Item is not available',
        pleaseChooseToCopy: 'You can just choose single record to copy',
        deadline: 'Expire Date',
        toExpireCount: 'Expire within three months',
        expiredCount: 'Expired',
        materialToExpireCount: 'Expire within three months',
        materialSixMonthExpireCount: 'Expire within six months',
        materialExpiredCount: 'Expired',
        pleaseMaintainNotionalValueOfAgreement: 'please maintain notional value of agreement',
        pleaseMaintainSSCategoryLeaderId: 'please choose SS Category Leader',
        pleaseMaintainPqcp: 'please maintain PQCP',
        pleaseMaintainAgreedSupply: 'please maintain Agreed Supply Quantity',
        priceError: ' ,please maintain newPricePerUomh and volumeEstimation',
        no: 'row:',
        productDescErr: ',please maintain product description',
        dcError: 'please choose Supplier DC',
        returnToSupplier: 'returnToSupplier',
        pleaseChooseApprovedToCopy: "you can only choose approved record to Copy",
        validDateCheck: 'Valid date from should  be earlier than Valid date TO',
        numSixBitCheck: 'Please input 6 decimal digits',
        adpRate: 'ADP Rate',
        adpRateCheck: 'You can only enter decimals greater than or equal to 0 and less than or equal to 1!',
        adpWithoutVatTotalCheck: 'input value is not equal to sum of adp without Vat in PQCP table',
        adpWithVatTotalCheck: 'input value is not equal to sum of adp with Vat in PQCP table',
        newPricePerUomSameCheck: 'new Price Per Uom is different',
        validDateFromSameCheck: 'Valid Date From is different',
        transportaionMethodSameCheck: 'transportaion Method is different ',
        suppliedDcSameCheck: 'reduplicated DC',
        dcListCheck:'DC list cannot be empty',
        sourceType:'createDepartment',
    }
}
